import Keycahin4 from '../../images/PortfolioImg/promotional/pvc keychine/p5.jpg'
import wristband from '../../images/PortfolioImg/promotional/wrist band/w4.jpg'
import sticker from '../../images/PortfolioImg/promotional/stikers/s6.jpg'
import flag from '../../images/PortfolioImg/promotional/flag/Flag.jpg'
import lanyard from '../../images/PortfolioImg/promotional/lanyard/Lanyard (2).jpg'
import pen from '../../images/PortfolioImg/promotional/pens/Promotional Pens.jpeg'

const PromotionalProductsData = [

  // {
  //   "id": 2,
  //   "name": "Bottles",
  //   "description": "Eco-friendly promotional bottles, perfect for events, gyms, and everyday use."
  // },
  {
    "id": 4,
    "name": "Wrist Bands",
    "description": "Custom hand bands, affordable and trendy for events, promotions, and giveaways.",
    image: wristband,
    key: 'bands'
  },
  {
    "id": 5,
    "name": "Stickers",
    "description": "Versatile, easy-to-distribute stickers that help spread brand awareness on any surface.",
    key: 'sticker',
    image: sticker
  },
  {
    id: 6,
    name: "PVC Keychains",
    description: "Flexible and colorful PVC keychains—perfect for fun, bold, and creative brand expressions.",
    key: "keychain",
    image: Keycahin4
  },
  {
    id: 7,
    name: "Flags",
    description: "Flexible and colorful PVC keychains—perfect for fun, bold, and creative brand expressions.",
    key: "flag",
    image: flag
  },
  {
    id: 8,
    name: "Custom Pens",
    description: "Flexible and colorful PVC keychains—perfect for fun, bold, and creative brand expressions.",
    key: "pen",
    image: pen
  },

  {
    id: 9,
    name: "Custom Lanyards",
    description: "Flexible and colorful PVC keychains—perfect for fun, bold, and creative brand expressions.",
    key: "lanyard",
    image: lanyard
  },
];

export default PromotionalProductsData;
